import { render, staticRenderFns } from "./SignCard.vue?vue&type=template&id=4e5ddd00"
import script from "./SignCard.vue?vue&type=script&lang=js"
export * from "./SignCard.vue?vue&type=script&lang=js"
import style0 from "./SignCard.vue?vue&type=style&index=0&id=4e5ddd00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports